import { getTextAssetCollectionConfig } from '@bingads-webui-campaign-react/pmax-text-input';

const dynamicCollectionConfig = isBusinessName => ({
  headlines: {
    labelText: isBusinessName ? _TL_('Business name') : _TL_('Text'),
    placeholderText: _TL_('Enter your text'),
    fieldName: 'short-headline',
    singleAssetValidationPropsField: 'Headline',
    validationPropsField: 'Headlines',
    addButtonText: _TL_('Add text'),
    copilotButtonLabel: _TL_('Get recommendations for your text'),
    deleteButtonLabel: _TL_('Remove text'),
    minCollectionSize: 1,
    maxCollectionSize: 1,
    errorMessage: isBusinessName ? _TL_('Business name is required') : _TL_('Text is required'),
    helpPopupTopic: 'pop_BA_VideoTemplates_Text',
    helpPopupAriaLabel: _TL_('Click to learn more about text'),
    inlineRecommendationsTitle: _TL_('Recommended texts'),
    inlineRecommendationsHelpTopicKey:
    'pop_BA_Recommendations_Pmax_Shortheadlines',
    inlineRecommendationsHelpTopicAriaLabel: _TL_('Click to learn more about text recommendations'),
    inlineRecommendationsDisabledItemTooltip: _TL_("You've reached the maximum number of texts. Please remove one text if you'd like to add this recommended text."),
    duplicateErrorMessage: _TL_('Duplicate texts are not allowed'),
  },
});

export const getShortHeadlineAssetCollectionConfig = (i18n, isBusinessName) => getTextAssetCollectionConfig('headlines', i18n, dynamicCollectionConfig(isBusinessName));

